<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import LoginForm from './LoginForm.svelte';

    export let allowSSO = true;
    export let loginUrl = `${PATH_PREFIX}/sw/api/login/`;
    export let ssoUrl = `${PATH_PREFIX}/sw/azure/login/`;
</script>

<style>
    .background {
        position: fixed;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .background-image {
        background-image: url('./images/login/background.jpg');
        background-repeat: no-repeat,no-repeat;
        background-position: center center,center center;
        background-size: cover,cover;
        z-index: 1000;
    }

    .background-overlay {
        background-color: #000;
        opacity: .5;
        z-index: 1001;
    }

    #login {
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        z-index: 1002;
        height: 100vh;
    }
</style>

<div class="background background-image">
    <div class="background background-overlay"></div>
</div>

<div id="login">
    <LoginForm {allowSSO} {loginUrl} {ssoUrl} />
</div>